
// Import common PlanMaster Vue components
// eslint-disable-next-line no-undef
const requireComponent = require.context(
    // The relative path of the components folder
    "@/components/common",
    // Whether or not to look in subfolders
    false,
    // The regular expression used to match base component filenames
    /\.vue$/
);

export const autoLoadComponents = () => {
    requireComponent.keys().forEach((fileName) => {
        // Get component config
        const componentConfig = requireComponent(fileName);
        // Strip the leading `./` and extension from the filename
        const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, "$1");
        // Register component globally
        Vue.component(
            componentName,
            // Look for the component options on `.default`, which will
            // exist if the component was exported with `export default`,
            // otherwise fall back to module's root.
            componentConfig.default || componentConfig
        );
    });
};
